import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./styles/index.css";
import { LandingPage } from "./pages/LandingPage";
import { ContactPage } from "./pages/ContactPage";
import { NotFoundPage } from "./pages/NotFoundPage";

// /kitchen-sink es una página interna de tokens: solo existe en `vite dev`.
// `import.meta.env.DEV` es literal `false` en el build, así que la ruta y el
// chunk no llegan a Hosting (B-6, QA 2026-10-30).
const KitchenSinkPage = import.meta.env.DEV
  ? lazy(() => import("./pages/KitchenSinkPage").then((m) => ({ default: m.KitchenSinkPage })))
  : null;

// apps/site — CERO Firebase (verificar con `npm ls firebase -w apps/site`
// vacío, ADR-004 §D-4.1). No importar nada de firebase/* aquí ni en ningún
// archivo bajo src/: es una imposibilidad estructural, no una disciplina.

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        {/* Página de verificación del punto 2 de "Criterios para dev" (ADR-004):
            kitchen sink de packages/tokens. Solo en desarrollo (B-6): no es parte
            del sitio comercial ni se publica. */}
        {KitchenSinkPage && (
          <Route
            path="/kitchen-sink"
            element={
              <Suspense fallback={null}>
                <KitchenSinkPage />
              </Suspense>
            }
          />
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
